import React from 'react';

const capabilities = [
  'Multimodal clinical intelligence',
  'Disease intelligence',
  'Patient stratification',
  'Longitudinal context',
];

const ClinicalIntelligence: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-serif font-bold text-4xl sm:text-5xl leading-tight tracking-tight text-[#085041]">
          <span className="text-[#0F6E56]">Clinical Intelligence</span>
        </h1>

        <p className="mt-6 text-lg leading-relaxed text-slate-700 max-w-3xl">
          Multimodal clinical intelligence for disease characterization,
          patient stratification, and longitudinal clinical context.
        </p>

        <section className="mt-10 bg-white border border-slate-200 rounded-xl p-8 sm:p-10 shadow-[6px_6px_0_rgba(15,110,86,0.14)]">
          <h2 className="font-serif font-bold text-2xl text-[#085041]">
            Clinical Intelligence Capabilities
          </h2>

          <div className="mt-6 grid sm:grid-cols-2 gap-4">
            {capabilities.map((item) => (
              <div
                key={item}
                className="border border-slate-200 rounded-lg p-5 bg-slate-50"
              >
                <p className="text-slate-700 font-medium">{item}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 grid md:grid-cols-2 gap-6">
          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Multimodal Clinical Reasoning
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Integrates clinical, diagnostic, and disease-context signals to
              support a fuller picture of patient state than any single
              data source alone.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Stratification &amp; Context
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Supports patient stratification and longitudinal context,
              connecting observations across a patient's clinical picture
              over time.
            </p>
          </div>
        </section>
      </section>
    </div>
  );
};

export default ClinicalIntelligence;
